import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DashboardForItComponent } from './dashboard-for-it/dashboard-for-it.component';
import {CalendarModule} from 'primeng/primeng';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import { DashboardSmsComponent } from './dashboard-sms/dashboard-sms.component';
import {EmailDashboardModule} from "../email-dashboard/email-dashboard.module";
import {DocumentRequestDashboardModule} from "../document-request-dashboard/document-request-dashboard.module";
import { DashboardDocumentComponent } from './dashboard-document/dashboard-document.component';
import {EmailDashboardComponent} from "../email-dashboard/email-dashboard.component";
import {DocumentRequestDashboardComponent} from "../document-request-dashboard/document-request-dashboard.component";
import { DashboardStorageComponent } from './dashboard-storage/dashboard-storage.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    NgbDropdownModule,
    TranslateModule,
    EmailDashboardModule,
    DocumentRequestDashboardModule
  ],
  declarations: [
    DashboardListComponent,
    DashboardForItComponent,
    DashboardSmsComponent,
    DashboardDocumentComponent,
    DashboardStorageComponent,
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard.module.ts